import { BaseService } from "../BaseService";

export interface LocationTypeLookup {
    locationTypeId: number;
    locationType: string;
}

class LocationTypeLookupServiceClass extends BaseService {
    protected get baseUrl(): string {
        return `${process.env.NEXT_PUBLIC_API_URL}/api/`;
    }

    async getLocationTypes(): Promise<LocationTypeLookup[]> {
        return this.get("location-types");
    }
}

export const locationTypeLookupService = new LocationTypeLookupServiceClass();
